// Some WebViews/privacy modes deny DOM storage, and merely reading
// `window.sessionStorage` then throws a SecurityError (ZULTI-APP-7TB).
// Fall back to a per-page in-memory store so the app keeps working.
export function safeStorage(name) {
  try {
    const storage = window[name];
    if (storage) return storage;
  } catch (_error) {
    // Fall through to the in-memory store.
  }

  const data = new Map();
  return {
    getItem: (key) => (data.has(key) ? data.get(key) : null),
    setItem: (key, value) => data.set(key, String(value)),
    removeItem: (key) => data.delete(key),
  };
}
